module.exports = __webpack_public_path__ + "img/syukyaku-de-003.20441c02.jpg";